import { CSSResultGroup, TemplateResult, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement } from 'lit/decorators.js';
import { SlotsNGController as SlotsController } from '../../controllers/slots-ng-controller';
import { SicCard } from '../sic-card/sic-card';
import '../sic-icon/sic-icon';

import componentStyles from './sic-card-tile.css.lit';
import defaultVars from './css-variables/sic-card-tile-vars.css.lit';

/**
 * The Sic Card Tile component
 * @element sic-card-tile
 *
 * @slot heading
 * @slot eyebrow
 * @slot description
 *
 * @attr external
 */
@customElement('sic-card-tile')
export class SicCardTile extends SicCard {
  static styles: CSSResultGroup = [componentStyles, defaultVars];
  slots = new SlotsController(this);

  render(): TemplateResult {
    const classes = this.mediaClasses();

    return html`
      <div class="card-wrapper ${classMap(classes)}">
        ${this.mediaTemplate()}
        <div slot="content" class="card-content">
          ${this.slots.conditionalSlot(
            'eyebrow',
            true,
            'card-eyebrow text-headline-eyebrow'
          )}
          ${this.slots.conditionalSlot('heading', true, 'card-heading')}
          ${this.slots.conditionalSlot('description', false)}
          ${this.slots.conditionalSlot('cta', false)}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-card-tile': SicCardTile;
  }
}
